import localeAntd from "ant-design-vue/lib/locale-provider/vi_VN";

const messages = {
  topBar: {
    issuesHistory: "Issues History",
    projectManagement: "Project Management",
    typeToSearch: "Search...",
    findPages: "Find pages...",
    actions: "Actions",
    status: "Status",
    profileMenu: {
      hello: "Xin chào",
      billingPlan: "Gói",
      role: "Quyền",
      email: "Email",
      phone: "Điện thoại",
      editProfile: "Cần sửa hồ sơ",
      logout: "Đăng xuất",
    },
  },
  authPage: {
    welcomeTo: "Chào mừng ",
    singinToAccount: "Đăng nhập vào tài khoản của bạn",
    plzInputYourName: "Vui lòng điền tên của bạn",
  },
};

// Custom format Date
const dateTimeFormats = {
  short: {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  },
  long: {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  },
};

export default {
  locale: "vi-VN",
  localeAntd,
  messages,
  dateTimeFormats,
};
